<!--
 * @Author: Yran
 * @Date: 2021-09-09 10:04:09
 * @LastEditors: LiuXin
 * @LastEditTime: 2021-09-26 17:02:26
-->
<template>
  <div class="detail_table_wrapper w100">
    <!-- chart图容器 -->
    <template v-for="c in children" :key="c">
      <component :is="c.component" v-bind="c"></component>
    </template>
  </div>
</template>

<script>
import DetailTable from './components/DetailTable.vue';
export default {
  name: '',
  components: {DetailTable},
    props: {
    children: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="less">
.detail_table_wrapper {
  display: flex;
  & > * {
    flex: 1;
    background-color: white;
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
}
</style>
